import { Box, Tooltip, Divider } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DevicesIcon from '@mui/icons-material/Devices';
import BugReportIcon from '@mui/icons-material/BugReport';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CableIcon from '@mui/icons-material/Cable';
import VerifiedIcon from '@mui/icons-material/Verified';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LanIcon from '@mui/icons-material/Lan';
import TerminalIcon from '@mui/icons-material/Terminal';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GavelIcon from '@mui/icons-material/Gavel';
import logo from '../assets/logo.jpeg';

const navItems = [
  { id: 'alerts',           label: 'Alerts',            icon: <NotificationsIcon /> },
  { id: 'dashboard',        label: 'Dashboard',         icon: <DashboardIcon /> },
  { id: 'assets',           label: 'Assets',            icon: <DevicesIcon /> },
  { id: 'vulns',            label: 'Vulnerabilities',   icon: <BugReportIcon /> },
  { id: 'stig',             label: 'STIG Compliance',   icon: <SecurityIcon /> },
  { id: 'c2c',              label: 'Comply to Connect', icon: <CableIcon /> },
  { id: 'ato',              label: 'ATO / RMF',         icon: <VerifiedIcon /> },
  { id: 'odp',              label: 'ODP',               icon: <GavelIcon /> },
  { id: 'export',           label: 'ATO Export',        icon: <FileDownloadIcon /> },
  { id: 'dmz',              label: 'Topology',          icon: <LanIcon /> },
  { id: 'arch',             label: 'Architecture',      icon: <AccountTreeIcon /> },
  { id: 'ai',               label: 'AI Assistant',      icon: <TerminalIcon /> },
];

const adminItems = [
  { id: 'user_management',  label: 'User Management',   icon: <ManageAccountsIcon /> },
];

export default function Sidebar({ activePage, setActivePage, permissions = [] }) {
  const visible      = navItems.filter(item => permissions.includes(item.id));
  const visibleAdmin = adminItems.filter(item => permissions.includes(item.id));

  const NavBtn = ({ item }) => {
    const isActive = activePage === item.id;
    return (
      <Tooltip key={item.id} title={item.label} placement="right" arrow>
        <Box
          onClick={() => setActivePage(item.id)}
          sx={{
            width: 44, height: 44,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            borderRadius: 2, cursor: 'pointer',
            color: isActive ? '#00bcd4' : '#7a8fa6',
            backgroundColor: isActive ? '#0d2137' : 'transparent',
            border: isActive ? '1px solid #1e3a5f' : '1px solid transparent',
            '&:hover': { color: '#00bcd4', backgroundColor: '#0d2137' },
            transition: 'all 0.15s ease',
          }}
        >
          {item.icon}
        </Box>
      </Tooltip>
    );
  };

  return (
    <Box sx={{
      width: 64, height: '100vh',
      backgroundColor: '#0d1117',
      borderRight: '1px solid #1e3a5f',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      position: 'fixed', left: 0, top: 0, zIndex: 100,
    }}>
      {/* Scrollable top section: logo + nav */}
      <Box sx={{
        flex: 1, overflowY: 'auto', overflowX: 'hidden',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        pt: 2, pb: 1, gap: 1, width: '100%',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}>
        <Box sx={{ mb: 2, flexShrink: 0 }}>
          <img src={logo} alt="Eighth Technologies" style={{ width: 36, height: 36, borderRadius: '50%' }} />
        </Box>
        <Box sx={{ width: '100%', height: '1px', backgroundColor: '#1e3a5f', mb: 1, flexShrink: 0 }} />
        {visible.map(item => <NavBtn key={item.id} item={item} />)}
      </Box>

      {/* Pinned bottom section: admin items always visible */}
      {visibleAdmin.length > 0 && (
        <Box sx={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, pb: 2, width: '100%' }}>
          <Box sx={{ width: '100%', height: '1px', backgroundColor: '#1e3a5f', mb: 1 }} />
          {visibleAdmin.map(item => <NavBtn key={item.id} item={item} />)}
        </Box>
      )}
    </Box>
  );
}
